import {paymentDefinition} from "./payment_definition";
import {logoDefinition} from "./logo_definition";
import {DefinitionsNameEnum} from "./DefinitionsName.enum";
import {paymentDoneDefinition} from "./payment_done_definition";
import { customETransportUploadDefinition } from './custom_etransport_upload_definition';

export const workflowsDefinitions = {
  [DefinitionsNameEnum.LOGO]: logoDefinition,
  [DefinitionsNameEnum.PAYMENTS]: paymentDefinition,
  [DefinitionsNameEnum.PAYMENT_DONE]: paymentDoneDefinition,
  [DefinitionsNameEnum.CUSTOM_ETRANSPORT_UPLOAD]: customETransportUploadDefinition
}

function flatten(obj: object, prefix = ''): Record<string, unknown> {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(acc, flatten(value, path));
    } else {
      acc[path] = value;
    }
    return acc;
  }, {} as Record<string, unknown>);
}

function unflatten(obj: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const key of Object.keys(obj)) {
    const keys = key.split('.');
    let current = result;
    for (let i = 0; i < keys.length - 1; i++) {
      current[keys[i]] = current[keys[i]] || {};
      current = current[keys[i]] as Record<string, unknown>;
    }
    current[keys[keys.length - 1]] = obj[key];
  }
  return result;
}

const flattened = flatten(workflowsDefinitions);
const flattenPath: Record<string, string> = {};
Object.keys(flattened).forEach((item) => {
  flattenPath[item] = item;
})
export const workflowsPathDefinitions = unflatten(flattenPath)
